import {Controller} from "stimulus"

export default class extends Controller {
    static targets = ["selectedContacts", "selectionNotice", "clearButton", "optionsList", "contactForm"];

    connect() {
        console.debug("inspection-contact-selector connected");
        this.restoreSelectionFromDataset();
    }

    selectContact(event) {
        event.preventDefault();
        console.log("inspection-contact-selector clicked");
        event.stopPropagation();
        const contactId = event.currentTarget.dataset.contactId;
        if (!contactId || !this.hasSelectedContactsTarget) {
            return;
        }

        const contactLabel = event.currentTarget.dataset.contactLabel || "Selected contact";
        const contactMethodIds = event.currentTarget.dataset.contactMethodIds || "";
        const contactMethodLabels = event.currentTarget.dataset.contactMethodLabels || "";
        const hasMethods = event.currentTarget.dataset.contactHasMethods === "true" || contactMethodIds.length > 0;

        this.removeHiddenSelectionInputs();
        this.selectedContactsTarget.innerHTML = "";
        const contactInfo = document.createElement("div");
        contactInfo.classList.add("contact-info");

        const heading = document.createElement("h4");
        heading.textContent = contactLabel;
        contactInfo.appendChild(heading);

        const contactIdInput = document.createElement("input");
        contactIdInput.type = "hidden";
        contactIdInput.name = "contact_id";
        contactIdInput.value = contactId;
        contactInfo.appendChild(contactIdInput);

        const contactMethodIdsInput = document.createElement("input");
        contactMethodIdsInput.type = "hidden";
        contactMethodIdsInput.name = "contact_method_ids";
        contactMethodIdsInput.value = contactMethodIds;
        contactInfo.appendChild(contactMethodIdsInput);

        this.element.dataset.selectedContactId = contactId;
        this.element.dataset.selectedContactLabel = contactLabel;
        this.element.dataset.selectedContactMethodIds = contactMethodIds;
        this.element.dataset.selectedContactMethodLabels = contactMethodLabels;

        this.selectedContactsTarget.appendChild(contactInfo);
        this.selectedContactsTarget.classList.remove("hidden");

        this.showSelectionNotice(contactLabel, hasMethods, contactMethodLabels);
        this.toggleClearButton(true);
        this.hideOptionsAndForm();
    }

    clear(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.hasSelectedContactsTarget) {
            this.selectedContactsTarget.innerHTML = "";
            this.selectedContactsTarget.classList.add("hidden");
        }
        this.removeHiddenSelectionInputs();
        this.resetDatasetSelection();
        this.showSelectionNotice(null, false, "");
        this.toggleClearButton(false);
        this.clearFormFields(true);
        this.showOptionsAndForm();
    }

    showSelectionNotice(label, hasMethods, contactMethodLabels) {
        if (!this.hasSelectionNoticeTarget) {
            return;
        }
        if (!label) {
            this.selectionNoticeTarget.classList.add("hidden");
            this.selectionNoticeTarget.textContent = "";
            return;
        }

        const methodsText = contactMethodLabels || "";
        let methodMessage = "";
        if (methodsText.length > 0) {
            methodMessage = ` - ${methodsText}`;
        } else if (!hasMethods) {
            methodMessage = " - No contact methods on file";
        }
        this.selectionNoticeTarget.textContent = `Using ${label}${methodMessage}`;
        this.selectionNoticeTarget.classList.remove("hidden");
    }

    toggleClearButton(showButton) {
        if (!this.hasClearButtonTarget) {
            return;
        }
        if (showButton) {
            this.clearButtonTarget.classList.remove("hidden");
        } else {
            this.clearButtonTarget.classList.add("hidden");
        }
    }

    hideOptionsAndForm() {
        if (this.hasOptionsListTarget) {
            this.optionsListTarget.classList.add("hidden");
        }
        if (this.hasContactFormTarget) {
            this.contactFormTarget.classList.add("hidden");
        }
    }

    showOptionsAndForm() {
        if (this.hasOptionsListTarget) {
            this.optionsListTarget.classList.remove("hidden");
        }
        if (this.hasContactFormTarget) {
            this.renderBlankFormFromTemplate();
            this.contactFormTarget.classList.remove("hidden");
        }
    }

    clearFormFields(resetIds = false) {
        if (!this.hasContactFormTarget) return;

        const inputs = this.contactFormTarget.querySelectorAll("input, textarea");
        inputs.forEach((input) => {
            if (resetIds && input.type === "hidden" && /\[id\]$/.test(input.name)) {
                input.value = "";
                return;
            }
            if (input.type === "hidden") {
                return;
            }
            if (input.type === "checkbox" || input.type === "radio") {
                input.checked = false;
            } else {
                input.value = "";
            }
        });

        if (resetIds) {
            const methodBlocks = Array.from(this.contactFormTarget.querySelectorAll("[data-contact-method-block]"));
            methodBlocks.slice(2).forEach((block) => block.remove());
        }
    }

    renderBlankFormFromTemplate() {
        const templateWrapper = document.querySelector("[data-new-contact-template]");
        if (!templateWrapper || !this.hasContactFormTarget) return;

        this.contactFormTarget.innerHTML = templateWrapper.innerHTML;
    }

    restoreSelectionFromDataset() {
        const {selectedContactId, selectedContactLabel, selectedContactMethodIds, selectedContactMethodLabels} = this.element.dataset;
        if (!selectedContactId) return;

        const mockEvent = {
            preventDefault() {},
            stopPropagation() {},
            currentTarget: {
                dataset: {
                    contactId: selectedContactId,
                    contactLabel: selectedContactLabel,
                    contactMethodIds: selectedContactMethodIds,
                    contactMethodLabels: selectedContactMethodLabels,
                    contactHasMethods: (selectedContactMethodIds || "").length > 0
                }
            }
        };
        this.selectContact(mockEvent);
    }

    removeHiddenSelectionInputs() {
        const hiddenInputs = this.element.querySelectorAll("input[name='contact_id'], input[name='contact_method_ids']");
        hiddenInputs.forEach((input) => input.remove());
    }

    resetDatasetSelection() {
        this.element.dataset.selectedContactId = "";
        this.element.dataset.selectedContactLabel = "";
        this.element.dataset.selectedContactMethodIds = "";
        this.element.dataset.selectedContactMethodLabels = "";
    }
}
